// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hiwHTObF{display:flex;flex-direction:column;gap:10px;padding:10px 10px 10px 37px}`, "",{"version":3,"sources":["webpack://./src/fsd/widgets/top-notification/ui/GlobalAlertsContent/GlobalAlertsContent.module.scss"],"names":[],"mappings":"AAAA,UACI,YAAA,CACA,qBAAA,CACA,QAAA,CACA,2BAAA","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    padding: 10px 10px 10px 37px;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `hiwHTObF`
};
export default ___CSS_LOADER_EXPORT___;
